export default __webpack_public_path__ + "static/media/Sanathan_STL_Cover_02062.d4e2933e.pdf";